import { NgIf } from '@angular/common'
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

@Component({
  selector: 'app-dialog',
  imports: [NgIf],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent implements OnInit {
  private fb = inject(FormBuilder)
  form!: FormGroup
  @Output() destroyMe = new EventEmitter<void>()

  ngOnInit() {
    this.initializeForm()
  }

  initializeForm() {
    this.form = this.fb.group({
      amount: ['', Validators.required],
      proof: ['', Validators.required]
    })
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  onClose() {
    this.destroyMe.emit()
  }
}
